export default [
    {
      path: '',
      name: 'servicesBuy',
      meta: {
        title: '购买确认'
      },
      component: () => import('@/views/services/index.vue')
    },
    {
      path: 'password',
      name: 'servicesPassword',
      meta: {
        title: '验证码确认'
      },
      component: () => import('@/views/services/password.vue')
    },
    {
      path: 'result',
      name: 'servicesResult',
      meta: {
        title: '支付'
      },
      component: () => import('@/views/services/payResult.vue')
    },
  ]
  